export default (fighter) => {
  if (fighter.thumbnail_overview) {
    fighter.thumbnail = fighter.thumbnail_overview;
  }
  return fighter;
};
